import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
  margin-bottom: 2.4rem;
`

export const GridSimpleCard = styled(Grid)``
